import React from 'react';
import {
  Button,
  useThemeStrings,
  GDSCustomizableComponent,
} from '@leagueplatform/genesis-core';
import { useInvokeAction } from '../../../hooks/use-invoke-action.hook';
import { MasonryDismissAction } from '../../../types/masonry-driver-node-actions';

type DismissButtonProps = {
  onDismiss: MasonryDismissAction;
  toolbarButton?: boolean;
} & GDSCustomizableComponent;

export const DismissButton = ({
  onDismiss,
  toolbarButton,
  css,
}: DismissButtonProps) => {
  const invokeAction = useInvokeAction();
  const strings = useThemeStrings();

  return (
    <Button
      className="dismiss-button"
      hideLabel
      size={toolbarButton ? 'toolbar' : 'medium'}
      icon="interfaceClose"
      priority="tertiary"
      css={css}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(!toolbarButton && { quiet: true })}
      onClick={(event: React.MouseEvent) => {
        if (onDismiss) {
          invokeAction({
            event,
            ...onDismiss,
          });
        }
      }}
    >
      {strings.dismiss}
    </Button>
  );
};
